import React from 'react';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { Briefcase, MapPin, Clock } from 'lucide-react';
import './Careers.css';

const Careers = () => {
  const jobs = [
    {
      id: 1,
      title: "Senior Full Stack Engineer",
      department: "Engineering",
      location: "Bengaluru, India (Hybrid)",
      type: "Full-time"
    },
    {
      id: 2,
      title: "Product Marketing Manager",
      department: "Marketing",
      location: "Remote (India)",
      type: "Full-time"
    },
    {
      id: 3,
      title: "Customer Success Specialist",
      department: "Customer Experience",
      location: "Mumbai, India",
      type: "Full-time"
    }
  ];

  return (
    <div className="careers-page">
      <SEO 
        title="Careers"
        description="Join FastInvoice and help us build the future of financial software for Indian businesses."
      />

      <section className="careers-hero">
        <div className="bg-glow glow-top-left"></div>
        <div className="careers-hero-content">
          <h1>Join the <span className="text-gradient">FastInvoice</span> Team</h1>
          <p>We're looking for passionate builders who want to make a real impact on how businesses operate.</p>
          <button className="btn-cta">View Open Positions</button>
        </div>
      </section>

      <section className="benefits-section">
        <div className="benefits-container">
          <h2>Why work with us?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>Remote-First</h3>
              <p>Work from anywhere in India. We believe in outcomes, not desk time.</p>
            </div>
            <div className="benefit-card">
              <h3>Health & Wellness</h3>
              <p>Comprehensive health coverage for you and your dependents.</p>
            </div>
            <div className="benefit-card">
              <h3>Continuous Learning</h3>
              <p>Annual stipend for courses, books, and conferences.</p>
            </div>
            <div className="benefit-card">
              <h3>Unlimited PTO</h3>
              <p>Take the time you need to recharge and come back at your best.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="jobs-section" id="open-positions">
        <div className="jobs-container">
          <h2>Open Positions</h2>
          <p className="jobs-sub">Don't see a perfect fit? Send your resume to careers@fastinvoice.in</p>
          
          <div className="jobs-list">
            {jobs.map(job => (
              <div key={job.id} className="job-card">
                <div className="job-info">
                  <h3>{job.title}</h3>
                  <div className="job-meta">
                    <span className="meta-item"><Briefcase size={16} /> {job.department}</span>
                    <span className="meta-item"><MapPin size={16} /> {job.location}</span>
                    <span className="meta-item"><Clock size={16} /> {job.type}</span>
                  </div>
                </div>
                <button className="apply-btn">Apply Now</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Careers;
